<span class="disabled">Прикрепить файлы:</span>
<input type="file" accept="image/*,video/*" capture="environment" (change)="onFilesSelected($event)" [disabled]="formCtrl.disabled" multiple data-testid="add-file-input">
@for (file of selectedFiles; track file; let i = $index) {
  <div class="flex">
    @if (file.type.startsWith('image/')) {
      <div>
        <img [src]="file.preview" alt="image-preview" style="max-height: 200px; max-width: 200px" data-testid="added-img">
      </div>
    }

    @if (file.type.startsWith('video/')) {
      <video [src]="file.preview" controls style="max-height: 200px; max-width: 200px"></video>
    }
    <button mat-icon-button type="button" (click)="removeFile(i)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
